import React from "react";

export function AccordionItem({ title, open, onToggle, children }) {
  return (
    <div className="bi-accItem">
      <button type="button" className="bi-accBtn" onClick={onToggle}>
        <div className="bi-accTitle">{title}</div>
        <div style={{ fontWeight: 900 }}>{open ? "−" : "+"}</div>
      </button>
      {open ? <div className="bi-accPanel">{children}</div> : null}
    </div>
  );
}
